import React, { Component } from 'react'
import { Button, Col, Modal, ModalBody, ModalHeader, Row, Form } from "shards-react";
import ApiPet from "../../api/Pet";

class ListPetComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {
            pets: [],
            message: null,
            modalDelete : false,
            delPet : {}
        }
        this.delete = this.deletePet.bind(this);
        this.editPet = this.editPet.bind(this);
        this.addPet = this.addPet.bind(this);
        this.reloadPetList = this.reloadPetList.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
    }

    componentDidMount() {
        this.reloadPetList();
    }



    reloadPetList() {
        ApiPet.fetchPetsByCustomer()
            .then((res) => {
                console.log('Size REsult : ',res);
                this.setState({pets: res.data.result});

            });
    }

    loadPet(petid) {
        this.setState({modalDelete : !this.state.modalDelete});
        ApiPet.fetchPetById(petid)
            .then((res) => {
                let pet = res.data.result;
                console.log("Pet TO EDIT " , res);
                this.setState({delPet : pet})
            });

            console.log("Pet STATE : " , this.state )
    }    


    deletePet() {
                                                                   
        let dPet = {id : this.state.delPet.id, name: this.state.delPet.name, description: this.state.delPet.name,date_of_birth : this.state.delPetdate_of_birth, height : this.state.delPet.height, weight : this.state.delPet.weight, 
            race_id : this.state.delPet.race_id, customer_id : this.state.delPet.customer_id, status : 'INACTIVE'};
        ApiPet.deletePet(dPet)
           .then(res => {
               this.setState({message : 'Pet deleted successfully.'});
               this.setState({pets: this.state.pets.filter(pet => pet.id !== dPet.id)});
               this.setState({modalDelete : !this.state.modalDelete});
           })

    }

    cancelDelete() {
        this.setState({modalDelete : !this.state.modalDelete});
    }    

    editPet(id) {
        window.localStorage.setItem("PetId", id);
        this.props.history.push('/edit-pet');
    }

    addPet() {
        window.localStorage.removeItem("PetId");
        this.props.history.push('/add-pet');
    }

    render() {
        const deleteMd = this.state.modalDelete;
        //console.log('Size cities : ' + this.state.cities.length);
        return (
            <div>

                 {/* --------------------------- MODAL WINDOW TO INSERT SERVICE ---------------------------------------------------------------- */}
                 
                 <div>
                    <Modal open={deleteMd} toggle={this.addService}>
                        <ModalHeader>Delete</ModalHeader>
                        <ModalBody>                 
                                            <Form>
                                                    <Row>
                                                    
                                                    <Col md="9" className="form-group">  
                                                    <label htmlFor="cboCounty">Are you sure you want to delete this record..?</label>   
        
                                                    </Col>
            


                                                    </Row>
                                                      
                                                        <Button size="sm" theme="primary" className="mb-2 mr-1" onClick={() => this.deletePet()}>
                                                            Confirm
                                                        </Button>  
                                                        <Button outline size="sm" theme="secondary" className="mb-2 mr-1" onClick={() => this.cancelDelete()}>
                                                            Cancel
                                                        </Button>  

                                            </Form>                                                         


                        </ModalBody>
                    </Modal>
                </div> 



              <Col sm="4" className="d-flex ml-auto my-auto">
                    <Button className="mx-auto ml-sm-auto mr-sm-0"  onClick={() => this.addPet()}>
                    <i className="material-icons">add</i> New Pet
                    </Button>
              </Col> 


              <div>
                <table className="table mb-0">
                    <thead className="bg-light"> 
                        <tr>
                            
                            <th scope="col" className="border-0">Name</th>
                            <th scope="col" className="border-0">Date of Birth</th>
                            <th scope="col" className="border-0">Heigth</th>
                            <th scope="col" className="border-0">Weight</th>
                            <th scope="col" className="border-0">Race</th>
                            <th scope="col" className="border-0">Action</th>
                        </tr>
                    </thead>
                    
                   
                    <tbody>
                        {
                            this.state.pets.map(
                        pet =>
                                    <tr key={pet.id}>
                                        <td>{pet.name}</td>
                                        <td>{pet.dateOfBirth}</td>
                                        <td>{pet.height}</td>
                                        <td>{pet.weight}</td>
                                        <td>{pet.race.name}</td>
                                         <td>
                                            
                                            <Button outline size="sm" theme="danger" className="mb-2 mr-1" onClick={() => this.loadPet(pet.id)}>
                                                <i className="material-icons">&#xE872;</i>
                                            </Button>                                            
                                            
                                            <Button outline size="sm" theme="info" className="mb-2 mr-1" onClick={() => this.editPet(pet.id)}>
                                                <i className="material-icons">&#xE254;</i>
                                            </Button>                                           
                                        </td>
                                    </tr>
                            )
                        }
                    </tbody>
                  
                </table>
                </div>

            </div>
        );
    }

}

export default ListPetComponent;